import React from 'react';
import PropTypes from 'prop-types';
import { AlertCard } from './AlertCard';
import { LoadingSpinner } from '../../../common/LoadingSpinner';
import styles from './ActionAlertSection.module.css';

export const ActionAlertSection = ({ alerts, loading, selectedPriorities, onPriorityToggle }) => {
  // Show loading only on initial load (when no data exists)
  if (loading) {
    return (
      <div className={styles.cardGrid}>
        <div className={styles.loadingContainer}>
          <LoadingSpinner />
          <span>Loading alert data...</span>
        </div>
      </div>
    );
  }

  // If no alerts, show empty state (but don't show errors during disconnections)
  if (!alerts || alerts.length === 0) {
    return (
      <div className={styles.cardGrid}>
        <div className={styles.emptyContainer}>
          <span>No alert data available</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.cardGrid}>
      {alerts.map((alert) => (
        <AlertCard
          key={alert.priority}
          priority={alert.priority}
          openCount={alert.openCount}
          closedCount={alert.closedCount}
          trend={alert.trend}
          isSelected={selectedPriorities?.has(alert.priority)}
          onClick={() => onPriorityToggle?.(alert.priority)}
        />
      ))}
    </div>
  );
};

ActionAlertSection.propTypes = {
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      priority: PropTypes.string.isRequired,
      openCount: PropTypes.number.isRequired,
      closedCount: PropTypes.number.isRequired,
      trend: PropTypes.oneOf(['up', 'down', 'balanced']).isRequired,
    })
  ),
  loading: PropTypes.bool,
  selectedPriorities: PropTypes.object,
  onPriorityToggle: PropTypes.func,
};